export default "__VITE_ASSET__87184007__"